import React, { useMemo, useState } from "react";

import { AdminLocationAlertsListControls } from "./Controls";
import { AdminLocationAlertsListHeader } from "./Header";
import { AdminLocationAlertItem } from "./Item";
import {
  AdminLocationAlertsQueryParams,
  AdminLocationAlertsQueryParamsSchema,
  defaultAdminLocationAlertsQueryParams,
} from "./types";
import useAdminLocationAlerts from "../../../containers/FacilityDetailsPage/hooks/useAdminLocationAlerts";
import { LocationAlertData } from "../../../models/LocationAlert";
import LocalStorageSvc from "../../../services/localStorageSvc";
import Pagination from "../../Pagination";

export const AdminLocationAlertsList = () => {
  const configData =
    LocalStorageSvc.getItem<AdminLocationAlertsQueryParams>(
      "AdminLocationAlertsTable_Config",
      AdminLocationAlertsQueryParamsSchema
    ) || defaultAdminLocationAlertsQueryParams;

  const [queryParams, setQueryParams] =
    useState<AdminLocationAlertsQueryParams>(configData);

  const { data, isLoading } = useAdminLocationAlerts(queryParams);

  const paginationData = useMemo(() => {
    const currentPageIndex =
      Math.floor(queryParams.offset / queryParams.limit) + 1;
    return {
      ...queryParams,
      pageIndex: currentPageIndex,
      numberPerPage: queryParams.limit,
    };
  }, [queryParams]);

  const handleSort = (sortField: string) => {
    setQueryParams((prev) => {
      const newOrder =
        prev.sort === sortField
          ? prev.order === "asc"
            ? "desc"
            : "asc"
          : "desc";
      const newValue = {
        ...prev,
        sort: sortField,
        order: newOrder,
      };

      LocalStorageSvc.setItem("AdminLocationAlertsTable_Config", newValue);

      return newValue;
    });
  };

  return (
    <div>
      <AdminLocationAlertsListControls
        value={queryParams}
        onChange={setQueryParams}
      />
      <div className="admin-location-alerts-list">
        <AdminLocationAlertsListHeader
          sortField={queryParams.sort}
          sortDirection={queryParams.order}
          handleSort={handleSort}
        />
        {!isLoading &&
          data?.data.map((locationAlert: LocationAlertData) => (
            <AdminLocationAlertItem
              key={locationAlert.id}
              locationAlert={locationAlert as LocationAlertData}
            />
          ))}
      </div>
      <Pagination
        filterFormData={paginationData}
        totalRowsNumber={data?.totalCount || 0}
        onChangeFilterFormData={setQueryParams}
      />
    </div>
  );
};
